import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { IssueByIdDocument } from "#app/lib/data";

// Tiny lookup hook for the item ShareDialog header — pulls the issue's
// display name + issue-type icon/name out of the IssueById cache.
// Lives in lib/hooks/ (Architecture Guard requires Apollo calls outside
// component files); the dialog wrapper just renders.
export function useIssueShareHeader(issueId: string | null) {
  const variables = useMemo(() => ({ issueId: issueId ?? "" }), [issueId]);
  const { data } = useQuery(IssueByIdDocument, {
    variables,
    skip: !issueId,
    fetchPolicy: "cache-first",
  });
  const issue = data?.issue;
  return {
    name: issue?.name ?? null,
    issueTypeName: issue?.issueType?.name ?? null,
    icon: issue?.issueType?.icon ?? null,
  };
}
